import { Box, Row, SeparatorLine } from '@stenajs-webui/core';
import { Tab, TabMenu } from '@stenajs-webui/elements';
import type { FC, ReactNode } from 'react';
import type { DetailedBooking } from '../../../../../common/graphql/fragments/gql/DetailedBooking';
import { PortPicturesView } from './PortPicturesView';
import type { BookingDetailsTabs } from './types';

interface Props {
  booking: DetailedBooking;
  children: ReactNode;
  gatePhotos: NonNullable<DetailedBooking['gatePhotos']>;
  setTab: (v: BookingDetailsTabs) => void;
  tab: BookingDetailsTabs;
}

export const BookingDetailsTabView: FC<Props> = ({
  gatePhotos,
  children,
  tab,
  setTab,
  booking,
}) => {
  return (
    <Box minHeight={650}>
      <Row indent={1}>
        <TabMenu>
          <Tab label={'Details'} selected={tab === 'details'} onClick={() => setTab('details')} />
          <Tab
            label={'Gate photos'}
            selected={tab === 'gate-photos'}
            onClick={() => {
              setTab('gate-photos');
            }}
          />
        </TabMenu>
      </Row>
      <SeparatorLine />

      {tab === 'gate-photos' ? (
        <PortPicturesView
          inboundHasCapability={gatePhotos.inboundHasCapability}
          outboundHasCapability={gatePhotos.outboundHasCapability}
          inbound={gatePhotos.inbound}
          outbound={gatePhotos.outbound}
          arrivalLocationName={booking.sailing.route.arrivalLocation.name}
          departureLocationName={booking.sailing.route.departureLocation.name}
        />
      ) : (
        children
      )}
    </Box>
  );
};
